$(() => {
	const blurb = $('.bs-blurb');
	const blurb_container = $('.bs-blurb__container');
	if (blurb.length > 0) {
		blurb.has('a').addClass('has-link');
		blurb_container.has('>a').addClass('outer-link');
		blurb.has('.bs-blurb__image').addClass('with-image');
	}
});
